module.exports = __webpack_public_path__ + "img/avatar2.e8f88dce.svg";